
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
  import {
    memberLabelmemberLabelUseDetail,
  } from "@/api/supplier"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate
    }
  })

  export default class ProductList extends Vue {
    private keywords = ''
    private rank = null
    private ranklist:any = [
      {
        label: '全部',
        value: null
      }, {
        label: '联创',
        value: 1
      }, {
        label: '核心',
        value: 2
      }, {
        label: '总代',
        value: 3
      }, 
    ]
    private tablelist:any = []
    private tableloading = false
		private pageNo = 1;
		private pageSize = 20;
		private total = 0;

    
    private mounted () {
      this.gettablelist()
    }



    private exportfile(){
      let url = location.origin + '/pc/memberLabel/memberLabelUseDetailExport'
      url += '?Id=' + this.$route.query.Id
      url += '&Keywords=' + encodeURIComponent(this.keywords)
      url += '&RoleGrade=' + (this.rank==null?'':this.rank)
      window.open(url)
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private clearSearch(){
      this.keywords = ''
      this.rank = null
      this.doSearch()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res = await memberLabelmemberLabelUseDetail({
          Id:this.$route.query.Id,
          RoleGrade:this.rank,
          Keywords:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
